// Unico punto di contatto con il backend.
// Prima si mescolavano axios e fetch grezzo, e la creazione di una lobby non
// controllava nemmeno response.ok: con un nome gia in uso non succedeva nulla.

const JSON_HEADERS = { 'Content-Type': 'application/json' };

export class ApiError extends Error {
    constructor(message, status) {
        super(message);
        this.name = 'ApiError';
        this.status = status;
    }
}

async function request(path, options = {}) {
    let response;
    try {
        response = await fetch(path, options);
    } catch (cause) {
        throw new ApiError('Server non raggiungibile. Controlla la connessione.', 0);
    }

    let body = null;
    const text = await response.text();
    if (text) {
        try {
            body = JSON.parse(text);
        } catch {
            body = null;
        }
    }

    if (!response.ok) {
        const detail = body?.detail;
        throw new ApiError(normaliseDetail(detail) ?? 'Richiesta non riuscita.', response.status);
    }
    return body;
}

function normaliseDetail(detail) {
    if (!detail) return null;
    if (typeof detail === 'string') return detail;
    // FastAPI restituisce una lista di errori di validazione.
    if (Array.isArray(detail)) {
        return detail
            .map((item) => item.msg ?? JSON.stringify(item))
            .join('; ');
    }
    return JSON.stringify(detail);
}

export function fetchPlayers() {
    return request('/api/players');
}

export function fetchDefaults() {
    return request('/api/config/defaults');
}

export function createAuction({ lobbyName, mode, settings, participantName }) {
    return request('/api/auctions', {
        method: 'POST',
        headers: JSON_HEADERS,
        body: JSON.stringify({
            lobby_name: lobbyName,
            mode,
            settings,
            participant: { name: participantName },
        }),
    });
}

export function joinAuction({ lobbyName, password, participantName, token }) {
    return request(`/api/auctions/${encodeURIComponent(lobbyName)}/join`, {
        method: 'POST',
        headers: JSON_HEADERS,
        body: JSON.stringify({
            password,
            participant: { name: participantName },
            // Se questo dispositivo ha gia una sessione per questa lobby, il
            // server la riconosce — ma solo insieme al nome a cui e stata
            // emessa: da un browser condiviso, un nome nuovo resta un ingresso
            // nuovo.
            token: token ?? '',
        }),
    });
}

export function spectateAuction({ lobbyName, password, token }) {
    return request(`/api/auctions/${encodeURIComponent(lobbyName)}/spectate`, {
        method: 'POST',
        headers: JSON_HEADERS,
        body: JSON.stringify({
            password,
            // Il token gia in memoria si rimanda: una ricarica della pagina non
            // deve consumarne uno nuovo.
            token: token ?? '',
        }),
    });
}

export function fetchAuctionSummary(lobbyName) {
    return request(`/api/auctions/${encodeURIComponent(lobbyName)}`);
}

export function deleteAuction(lobbyName, token) {
    return request(
        `/api/auctions/${encodeURIComponent(lobbyName)}?token=${encodeURIComponent(token)}`,
        { method: 'DELETE' },
    );
}

/** Indice player_id -> record, usato ovunque per espandere le rose. */
export function indexPlayers(players) {
    const index = {};
    (players ?? []).forEach((player) => {
        index[player.ID] = player;
    });
    return index;
}
